﻿import * as React from 'react';
import Typography from '@mui/material/Typography';

type SystemVersionProps = {
    systemVersion: string;
};

function SystemVersion({ systemVersion }: SystemVersionProps) {
    return (
        <Typography
            variant="body1"
            sx={{
                color: '#BDBDBD',
                fontSize: '12px',
                fontFamily: 'Gilroy-Regular',
                letterSpacing: '0.4px'
            }}
        >
            {systemVersion}
        </Typography>
    );
}

export default SystemVersion;
